<template>
    <div class="modal-content">
        <h2 class="modal-title title-coupons lg-cond text-center pt-10 pb-10">
            {{ title }}
        </h2>
        <div class="control number">
            <button class="decrement-button" :disabled="decrementDisabled" @click="decrement">−</button>
            <button class="increment-button" :class="incrementDisabled && 'disabled'" :disabled="incrementDisabled" @click="increment">+</button>
            <input
                    type="text"
                    disabled="disabled"
                    :min="min"
                    :max="max"
                    :step="step"
                    v-model.number="currentValue"
                    @blur="currentValue = value"
                    @keydown.esc="currentValue = value"
                    @keydown.enter="currentValue = value"
                    @keydown.up.prevent="increment"
                    @keydown.down.prevent="decrement"
            />
            <!--:disabled="inputDisabled"-->
        </div>
        <div v-if="isShowMessage" class="message_hut_reward xs-text-center pb-15" v-html="messageText"></div>
        <div class="btn-group btn-group-justified" role="group">
            <button type="button" @click="$emit('close')"
                    class="btn btn-danger button-coupon-text t16 fw600">{{$t('close')}}
            </button>
            <button type="button" @click="update(currentValue)"
                    class="btn btn-success button-coupon-text t16 fw600">{{$t('btn_save')}}
            </button>
        </div>

    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import * as types from '@/store/types'
    export default {
        props: {
            disabled: Boolean,
            max: {
                type: Number,
                default: Infinity
            },
            min: {
                type: Number,
                default: -Infinity
            },
            value: {
                required: true
            },
            step: {
                type: Number,
                default: 1
            },
            title: {
                type: String,
                required: true
            },
            update: {
                type: Function
            },
            isHutReward: {
                type: Boolean,
                default: false
            },
            customize: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            point: {
                type: [Number, Text],
                default: 0
            }
        },
        data() {
            return {
                currentValue: this.value,
                decrementDisabled: false,
                incrementDisabled: false,
                inputDisabled: false,
                isShowMessage: false,
                messageText: '',
                totalHutReward: 0,
                maxRedeemHutReward: 1,
                remainingPoints: 0
            }
        },
        computed: {
            ...mapGetters({
            hutReward: types.GET_HUT_REWARD,
            getMaxItemHutReward: types.GET_MAX_ITEM_HUT_REWARD
            })
        },
        watch: {
            value(val) {
                this.currentValue = val
            }
        },
        mounted() {
            if (this.value == this.min) {
                this.decrementDisabled = true
            }
            const cart = this.$cart.get(this)
            this.totalHutReward = this.sumOfHutRewardInCart(cart)
            this.maxRedeemHutReward = (this.customize && this.customize.maximum_quantity_redemption) || 1
            this.remainingPoints = this.hutReward.point + (this.currentValue * this.point)
            
            this.verifyRedeemHutReward()
        },
        methods: {
            verifyRedeemHutReward () {
                
                if (this.isHutReward) {
                    if (this.currentValue >= this.maxRedeemHutReward) {
                        this.isShowMessage = true
                        this.messageText = this.$t('message_limit_item', {slice: this.maxRedeemHutReward})
                        this.incrementDisabled = true
                        return
                    } else if (this.totalHutReward >= this.getMaxItemHutReward) {
                        this.isShowMessage = true
                        // this.messageText = this.$t('message_limit_item', {slice: this.getMaxItemHutReward})
                        this.incrementDisabled = true
                        return
                    } else if (this.remainingPoints - (this.currentValue * this.point) <= this.point) {
                        this.isShowMessage = true
                        this.messageText = this.$t('need_more_slice')
                        this.incrementDisabled = true
                        return
                    } else {
                        this.totalHutReward += 1
                        this.isShowMessage = false
                        this.incrementDisabled = false
                        this.messageText = ''
                    }
                }
            },
            increment() {
                if (this.disabled || this.incrementDisabled) {
                    return
                }

                let newVal = this.currentValue + 1 * this.step
                this.decrementDisabled = false

                this._updateValue(newVal)
                this.verifyRedeemHutReward()
            },
            decrement() {
                if (this.disabled || this.decrementDisabled) {
                    return
                }
                if (this.isHutReward) {
                    this.totalHutReward -= 1
                    this.isShowMessage = false
                    this.incrementDisabled = false
                }

                let newVal = this.currentValue + -1 * this.step
                this.incrementDisabled = false

                this._updateValue(newVal)
                this.verifyRedeemHutReward()
            },
            _updateValue(newVal) {
                const oldVal = this.currentValue

                if (oldVal === newVal || typeof this.value !== 'number') {
                    return
                }
                if (newVal <= this.min) {
                    newVal = this.min
                    this.decrementDisabled = true
                }
                if (newVal >= this.max) {
                    newVal = this.max
                    this.incrementDisabled = true
                }
                this.currentValue = newVal
                this.$emit('input', this.currentValue)
            }
        }
    }
</script>

<style scoped>
    .close {
        margin-top: 0;
    }

    button {
        margin: auto;
        width: 100%;
        margin-top: 20px;
    }

    .modal-notify {
        max-width: 400px;
        margin: auto;
        background: white;
        padding: 15px;
    }

    .alert-danger2 {
        color: #a94442;
        font-weight: bold;
    }

    .free-menu-description {
        cursor: pointer;
    }

    .v--modal-box {
        height: auto !important;
        top: 50px !important;
    }

    .modal-coupon .v--modal {
        min-width: 0px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/popup/ModalUpdateCart.vue